/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable()
export class DialogNotificationService {
  private refreshDialogsListeners = new Subject<any>();

  constructor() {}

  getRefreshDialogsListener(): Subject<any> {
    return this.refreshDialogsListeners;
  }

  refreshDialogs(): void {
    this.refreshDialogsListeners.next();
  }
}
